export default "__VITE_ASSET__WhboyhTH__"